// Gated by process.env.DEBUG_LOGGING (config/webpack.config.common.js),
// not NODE_ENV - unlike applogger.js, this stays off in a normal
// production build but can be deliberately turned on in one (e.g. to
// debug hydration/catalogue-loading behavior on a review site) without
// enabling dev-mode logging generally. Same no-op-when-off pattern as
// applogger.js, so DefinePlugin + Terser strip the console binding
// entirely when the flag isn't set at build time.
let debuglogger = {
  log: () => {},
  info: () => {},
  warn: () => {}
}

if (process.env.DEBUG_LOGGING) {
  debuglogger = {
    log: console.log.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console)
  }
}

export default debuglogger
